import { render, staticRenderFns } from "./AppButtonContact.vue?vue&type=template&id=06f06195&scoped=true&"
import script from "./AppButtonContact.vue?vue&type=script&lang=js&"
export * from "./AppButtonContact.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonContact.vue?vue&type=style&index=0&id=06f06195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f06195",
  null
  
)

export default component.exports